import { Icons } from '@/configs/icons';
import styles from './style.module.scss';
import { useRouter } from 'next/router';
import { ERROR } from '@/configs/constants';
import PageLayout from '../Layouts/PageLayout';

interface errorObj {
  statusCode: number;
  message: string;
}
/* eslint-disable @next/next/no-html-link-for-pages */
export const NotFoundError = ({ statusCode, message }: errorObj) => {
  const router = useRouter();
  console.error('ERROR:', message);
  return (
    <PageLayout dataTestId="errorContent">
      <section className="">
        <h1 className={`text-center mb-8 ${styles.errorCode}`}>{statusCode}</h1>
        <h4 className={`text-center ${styles.errorDesc}`}>
          {message ? message : ERROR.NOT_FOUND_DESC}
        </h4>
        <p className={`text-center ${styles.errorNav}`}>
          All you have to do is go back to our home page or the previous page, to connect back to
          us.
        </p>
        <div
          className={`w-1/5 mb-6 mt-6 flex flex-row flex-wrap justify-center space-x-8 ${styles.btnContainer}`}
        >
          <a
            className={`${styles.btn} text-center leading-10`}
            title="Home Page"
            aria-label="Home Page"
            href="/"
          >
            Home Page
          </a>
          <a
            className={`${styles.btn} text-center leading-10`}
            title="Back"
            aria-label="Back"
            onClick={() => router.back()}
          >
            Back
          </a>
        </div>
      </section>
    </PageLayout>
  );
};
/* eslint-enable @next/next/no-html-link-for-pages */

export default NotFoundError;
